import React from "react"
import { useTranslation } from "react-i18next"

import { Accordion, Panel } from "~/components/Accordion/Accordion"
import { Breadcrumbs } from "~/components/Breadcrumbs/Breadcrumbs"
import { Share } from "~/components/ContentEditable/components/Share/Share"
import { ContentEditable } from "~/components/ContentEditable/ContentEditable"
import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"
import { Model } from "~/views/responsible-investment-principles/components/Model/Model"

import styles from "./index.module.css"

export const Content: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.Wrapper}>
      <Breadcrumbs />

      <div className="grid grid--col-12">
        <ContentEditable className={styles.ColLeft}>
          <div className={styles.Block}>
            <Heading like="h1">
              <Raw html={t("responsible-investment-principles.Title")} />
            </Heading>

            <p
              dangerouslySetInnerHTML={{
                __html: t("responsible-investment-principles.Paragraph.01"),
              }}
            />

            <p
              dangerouslySetInnerHTML={{
                __html: t("responsible-investment-principles.Paragraph.02"),
              }}
            />

            <p
              dangerouslySetInnerHTML={{
                __html: t("responsible-investment-principles.Paragraph.08"),
              }}
            />

            <p />
            <Accordion>
              <Panel question={t("responsible-investment-principles.Accordion.Q.01")}>
                <Raw html={t("responsible-investment-principles.Accordion.A.01")} />
              </Panel>
              <Panel question={t("responsible-investment-principles.Accordion.Q.02")}>
                <Raw html={t("responsible-investment-principles.Accordion.A.02")} />
              </Panel>
              <Panel question={t("responsible-investment-principles.Accordion.Q.03")}>
                <Raw html={t("responsible-investment-principles.Accordion.A.03")} />
              </Panel>
              <Panel question={t("responsible-investment-principles.Accordion.Q.04")}>
                <Raw html={t("responsible-investment-principles.Accordion.A.04")} />
              </Panel>
              <Panel question={t("responsible-investment-principles.Accordion.Q.05")}>
                <Raw html={t("responsible-investment-principles.Accordion.A.05")} />
              </Panel>
              <Panel question={t("responsible-investment-principles.Accordion.Q.06")}>
                <Raw html={t("responsible-investment-principles.Accordion.A.06")} />
              </Panel>
            </Accordion>

            <Heading like="h4">
              <Raw html={t("responsible-investment-principles.Heading.01")} />
            </Heading>

            <p
              dangerouslySetInnerHTML={{
                __html: t("responsible-investment-principles.Paragraph.03"),
              }}
            />

            <ul>
              <li
                dangerouslySetInnerHTML={{
                  __html: t("responsible-investment-principles.List.01.Item.01"),
                }}
              />

              <li
                dangerouslySetInnerHTML={{
                  __html: t("responsible-investment-principles.List.01.Item.02"),
                }}
              />
            </ul>

            <p
              dangerouslySetInnerHTML={{
                __html: t("responsible-investment-principles.Paragraph.04"),
              }}
            />

            <Heading like="h4">
              <Raw html={t("responsible-investment-principles.Heading.02")} />
            </Heading>
          </div>

          <Model />

          <div className={styles.Block}>
            <Share />
          </div>
        </ContentEditable>
      </div>
    </div>
  )
}
